<div class="modal-dark set-up-tutorial-modal">
  <div class="modal-header">
    <img
      [src]="steps[currentStep - 1].imgSrc"
      alt="{{ steps[currentStep - 1].title }}" />
  </div>
  <div
    class="modal-body"
    [class.step-forward]="animationDirection === 'forward'"
    [class.step-backward]="animationDirection === 'backward'">
    @if (userProfile$ | async; as user) {
      @if (currentStep === 1) {
        <div>
          <h4>
            {{ steps[currentStep - 1].title }},<br />
            {{ user.first_name }}!
          </h4>
        </div>
      }
    }

    @if (currentStep !== 1) {
      <div>
        <h4>{{ steps[currentStep - 1].title }}</h4>
        <p>{{ steps[currentStep - 1].description }}</p>
      </div>
    }
  </div>

  <div class="modal-footer justify-content-between">
    <div>
      @if (currentStep > 1) {
        <small class="text-muted">Step {{ currentStep - 1 }} of {{ totalSteps - 1 }}</small>
      }
    </div>
    <div>
      @if (currentStep > 1) {
        <button
          class="btn btn-outline-dark mx-2"
          (click)="prevStep()">
          Back
        </button>
      }
      @if (currentStep >= 1 && currentStep !== totalSteps) {
        <button
          (click)="nextStep()"
          class="btn btn-secondary"
          type="submit">
          {{ currentStep === 1 ? 'Continue' : 'Next' }}
        </button>
      }
      @if (currentStep === totalSteps) {
        @if (currentStep === totalSteps) {
          <button
            (click)="noApiRequired ? close() : finishSetup()"
            class="btn btn-secondary">
            Done
          </button>
        }
      }
    </div>
  </div>
</div>
